<template>
    <iframe ref="mailIframe" @load="initMailIframe" :key="renderId"></iframe>
</template>
<script>
export default {
    name: "MailPreview",
    props: {
        html: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        renderId: 0,
        cancels: [],
    }),
    mounted() {
        this.initMailIframe();
    },
    methods: {
        initMailIframe() {
            const iframe = this.$refs.mailIframe;
            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(this.html);
            doc.close();
            doc.body.style.margin = "0";
            doc.body.style.padding = "0";
            doc.body.style.height = "max-content";
            doc.body.style.fontFamily = "Arial, sans-serif";

            this.loadedIframe();
            this.$nextTick(() => this.loadedIframe());
            const loadedFn = () => {
                this.loadedIframe();
            };
            iframe.contentWindow.addEventListener("load", loadedFn);
            const timeout = setTimeout(() => {
                this.loadedIframe();
            }, 200);
            this.cancels.push(() => {
                iframe.contentWindow?.removeEventListener("load", loadedFn);
                clearTimeout(timeout);
            });
        },
        loadedIframe() {
            const iframe = this.$refs.mailIframe;
            iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
        },
    },
    watch: {
        html: {
            deep: true,
            handler() {
                this.cancel.forEach((cancel) => cancel());
                this.renderId += 1;
                this.initMailIframe();
            },
        },
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
};
</script>
<style lang="scss" scoped>
iframe {
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
